import { combineReducers } from '@reduxjs/toolkit';
import { History } from 'history';
import { connectRouter } from 'connected-react-router';

import * as featureReducers from 'features/reducers';
import * as moduleReducers from './reducers';

export default function createRootReducer(history: History) {
  return combineReducers({
    ...moduleReducers,
    ...featureReducers,
    router: connectRouter(history),
  });
}

declare global {
  type IRootState = ReturnType<typeof createRootReducer>;
}
